import { PropsWithChildren } from 'react'

import styled, { css } from 'styled-components'

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.background};
`

export const PressAbleContainer = styled.button<PropsWithChildren<object>>`
  padding: 20px;
  display: flex;
  flex-direction: row;
  gap: 20px;
  border: none;
  cursor: pointer;
  background: none;
  width: 100%;
`

export const OptionLabel = styled.span`
  flex: 1;
  flex-wrap: wrap;
  ${({ theme }) => css`
    font-size: 16px;
    color: ${theme.colors.text};
  `}
`

export const SheetModalContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`
